import { useState } from "react";

import Form from "react-bootstrap/Form";

const FormControl = ({ field, register, errors }) => {
  const [htmlType, setHtmlType] = useState("text");
  return (
    <Form.Control
      type={field?.htmlType === "date" ? htmlType : field?.htmlType}
      placeholder={field?.placeholder}
      {...register(field.name)}
      disabled={field?.disabled}
      isInvalid={errors && field.name in errors}
      onFocus={() => setHtmlType("date")}
      onBlur={() => setHtmlType("text")}
    />
  );
};

export default FormControl;
